import $ from "jquery";
import Swiper from 'swiper/bundle';

$(function() {
    $(".bl-aktuellboxes").each(function() {
        const $bl = $(this);
        initSlider($bl);
        initContainerLinks($bl);
    });
});

function initSlider($bl) {
  const numSlides = $bl.find(".swiper-slide").length;
  const slidesPerView = Math.min(numSlides, 3);

  const swiper = new Swiper($bl.find('.swiper').get(0), {
      //loop: true,
      //rewind: true,
      //autoHeight: true,
      slidesPerView: 1,
      centerInsufficientSlides: true,
      spaceBetween: 20,
      
      pagination: {
        el: $bl.find('.swiper-pagination').get(0),
        clickable: true
      },

      navigation: {
        nextEl: $bl.find('.button-next').get(0),
        prevEl: $bl.find('.button-prev').get(0),
      },

      /*
      speed: 1500,
      autoplay: {
        delay: 4000
      }
      */

      
      breakpoints: {
        // when window width is >= 600px
        600: {
          slidesPerView: Math.min(slidesPerView, 2)
        },
        // when window width is >= 1024px
        1024: {
          slidesPerView: slidesPerView
        }
      }
  });
}

function initContainerLinks($bl) {
  $bl.find(".ctrslidecontent").each(function() {
    const $slidecontent = $(this);
    const $links = $slidecontent.find("a");
    if($links.length != 1) {
      //Multiple links (or no links at all) not supported.
      return;
    }

    //Box has only one link.
    //=> Add click handler that forwards click to link
    //=> Add cursor:pointer
    $slidecontent.css("cursor", "pointer");
    $slidecontent.on("click", function(e) {
      const isInsideLink = $(e.target).closest("a", this).length > 0;
      if (isInsideLink) {
        // The click originated inside an <a> element within this container
        return;
      }

      $links[0].click();
    });
  });
}